"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDialog = void 0;
var react_1 = __importDefault(require("react"));
var DialogService_1 = require("../contexts/DialogService");
exports.useDialog = function () { return react_1.default.useContext(DialogService_1.DialogServiceContext); };
